enum ClientLanguage {
  EN = "en-GB",
  DE = "de-DE",
}

export default ClientLanguage;
